package one.healthium.domain.user.models

data class SymptomsLogOptions(
    val symptoms: List<SymptomModel>,
)
